<!-- Page header: título a la izquierda, acciones a la derecha (fuera de la tarjeta) -->
<div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
	<div>
		<h4 class="mb-1">Users</h4>
	</div>

	<div class="d-flex flex-wrap gap-2">
		<button type="button" class="btn btn-success btn-label waves-effect waves-light rounded-pill"
			(click)="openAddUserModal(addUserModal)">
			<i class="ri-add-circle-fill label-icon align-middle rounded-pill fs-16 ms-2"></i>
			Add User
		</button>
	</div>
</div>

<div class="row">
	<div class="col-md-4">
		<div class="card card-animate card-blue">
			<div class="card-body">
				<p class="text-muted mb-0">Total Customers</p>
				<h3>{{ clientCount }}</h3>
				<small class="text-muted">
					{{ currentStatus == 1 ? "Active accounts" : "Inactive accounts" }}
				</small>
			</div>
		</div>
	</div>
	<div class="col-md-4">
		<div class="card card-animate card-green">
			<div class="card-body">
				<p class="text-muted mb-0">Online Now</p>
				<h4>{{ onlineUsersCount }}</h4>
				<small class="text-muted">in portal</small>
			</div>
		</div>
	</div>
	<div class="col-md-4">
		<div class="card card-animate card-green">
			<div class="card-body">
				<p class="text-muted mb-0">Open QC Reviews</p>
				<h4>{{ totalOpenQcReviews }}</h4>
				<small class="text-muted">awaiting response</small>
			</div>
		</div>
	</div>
	<!-- <div class="col-md-3">
		<div class="card card-animate card-red">
			<div class="card-body">
				<p class="text-muted mb-0">Emails Tracked</p>
				<h4 class="text-danger">0</h4>
				<small class="text-muted">last 7 days</small>
			</div>
		</div>
	</div> -->
</div>
<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-body">
				<ul ngbNav #nav="ngbNav" class="nav nav-tabs nav-justified d-none">
					<li [ngbNavItem]="1">
						<!-- <a ngbNavLink>Users Module</a> -->
						<ng-template ngbNavContent>
							<h3 class="text-danger">{{ msgError }}</h3>
							<form class="content-filters">
								<div class="row mt-2 align-items-end">
									<div class="col-md-5">
										<h5>Search</h5>
										<input type="text" class="form-control"
											placeholder="Search by Name, login, email, company..."
											(keyup)="updateFilterUnified($event)" />
									</div>

									<div class="col-md-7">
										<div class="d-flex justify-content-end align-items-center gap-4">
											<!-- Active / Inactive -->
											<div class="users-toggle">
												<button type="button" class="toggle-option"
													[class.active]="currentStatus === 1"
													(click)="filterByStatus(1)">Active</button>
												<button type="button" class="toggle-option"
													[class.active]="currentStatus === 0"
													(click)="filterByStatus(0)">Inactive</button>
											</div>

											<!-- Portal -->
											<div class="form-group d-flex align-items-center">
												<label class="headerSearch me-2 mb-0">Portal</label>
												<div ngbDropdown>
													<button class="btn btn-primary" id="portalDrop" ngbDropdownToggle>{{
														filterPortal }}</button>
													<div ngbDropdownMenu aria-labelledby="portalDrop">
														<button ngbDropdownItem
															(click)="filterByPortal('All')">All</button>
														<button ngbDropdownItem
															(click)="filterByPortal('Admin')">Admin</button>
														<button ngbDropdownItem
															(click)="filterByPortal('Caller')">Caller</button>
														<button ngbDropdownItem
															(click)="filterByPortal('Customer')">Customer</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</form>

							<br />

							<div *ngIf="!loading">
								<div class="table-responsive">
									<table class="cc-table-users no-card-padding">
										<thead>
											<tr>
												<th class="text-center" style="width: 70px; padding-right: 10px">Active
												</th>
												<th style="width: 20px">User</th>
												<th style="width: 180px">Company</th>
												<th style="width: 140px">Campaign</th>
												<th class="text-center" style="width: 200px">Last Login</th>
												<th class="text-center">Open QC</th>
												<th class="text-centert">Contact</th>
												<th class="text-center">Password</th>
												<th class="text-center" style="width: 150px">Email Options</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let row of allUsers; let i = index"
												(dblclick)="openEditUser(row.id, row.role)" style="cursor: pointer">
												<td class="text-center" style="padding-right: 10px">
													<div class="form-check form-switch d-inline-block">
														<input *ngIf="row['isActive'] == 1" class="form-check-input"
															type="checkbox" role="switch" checked
															(click)="row.portalType === 'Employee' ? deactivateUserConfirm(row) : deactivateClientUserConfirm(row)" />
														<input *ngIf="row['isActive'] == 0" class="form-check-input"
															type="checkbox" role="switch"
															(click)="row.portalType === 'Employee' ? activateUserConfirm(row) : activateClientUserConfirm(row)" />
													</div>
												</td>

												<td>
													<div class="d-flex align-items-center">
														<div class="avatar"
															[ngStyle]="{ 'background-color': getAvatarColor(row.name) }">
															{{ getInitials(row.name) }}
														</div>
														<div class="ms-2">
															<div>
																<span class="fw-bold">{{ row.name }}</span>
																<span *ngIf="row.alias" class="text-muted ms-1">{{
																	row.alias }}</span>
															</div>
															<div class="text-muted small d-flex align-items-center">
																<span>{{ row.email1 }}</span>
																<!-- <span class="status-dot ms-1" [class.dot-sent]="row.welcome_email_sent == 1" [class.dot-pending]="row.welcome_email_sent != 1" [ngbTooltip]="row.welcome_email_sent == 1 ? 'Welcome email sent' : 'Welcome email pending'" placement="top"> </span> -->
															</div>
															<div>
																<span *ngIf="row.role === 'SADM'"
																	class="badge bg-dark ms-1">Super Admin</span>
																<span *ngIf="row.role === 'ADM'"
																	class="badge bg-danger ms-1">Admin</span>
																<span *ngIf="row.role === 'CAL'"
																	class="badge bg-success ms-1">Caller</span>
																<span *ngIf="row.role === 'CUS'"
																	class="badge bg-info ms-1">Customer</span>
															</div>
														</div>
													</div>
												</td>
												<td>
													<span *ngIf="row.portalType === 'Customer'">
														{{ row.company_name }}
													</span>
													<span *ngIf="row.portalType === 'Employee'"> T3 Direct </span>
												</td>
												<td>
													<span class="pill pg" *ngIf="row.campaign_name">{{ row.campaign_name
														}}</span>
													<span *ngIf="!row.campaign_name" class="text-muted">-</span>
												</td>
												<td class="text-center">
													<span *ngIf="row.last_signin">{{ row.last_signin | utcToLocal
														}}</span>
													<span *ngIf="!row.last_signin" class="text-muted">-</span>
												</td>
												<td class="text-center">
													<div ngbDropdown class="d-inline-block"
														*ngIf="row.open_qc_reviews > 0">
														<span ngbDropdownToggle class="text-danger fw-bold no-caret"
															style="cursor: pointer">
															{{ row.open_qc_reviews }}
														</span>

														<div ngbDropdownMenu>
															<button ngbDropdownItem disabled>Unreviewed: {{
																row.unreviewed_count }}</button>

															<button ngbDropdownItem disabled>Fix: {{ row.fix_count
																}}</button>
														</div>
													</div>

													<span *ngIf="row.open_qc_reviews === 0" class="text-muted"> -
													</span>
												</td>
												<td class="text-center">
													<div class="usr-actions">
														<button class="usr-action-btn" title="Send Email"
															(click)="openMail(row.email1)">
															<i class="ri-mail-line"></i>
														</button>

														<a *ngIf="row?.phone_mobile" [href]="'tel:' + row.phone_mobile"
															class="btn btn-sm btn-primary usr-action-btn" title="Call">
															<i class="ri-phone-line"></i>
														</a>

														<!-- <button class="usr-action-btn" title="Text" (click)="textUser(row)">
																<i class="ri-message-2-line"></i>
															</button> -->
													</div>
												</td>

												<td class="text-center">
													<ng-container *ngIf="row.portalType === 'Employee'">
														<span class="pointer" *ngIf="showPass !== row.id"
															(click)="showPass = row.id"> ***** <i
																class="ri-eye-line"></i> </span>
														<span class="pointer" *ngIf="showPass === row.id"
															(click)="showPass = -1"> {{ getUserPass(row.name) }} <i
																class="ri-eye-off-line"></i> </span>
													</ng-container>
													<span *ngIf="row.portalType === 'Customer'">-</span>
												</td>

												<td class="text-center">
													<div ngbDropdown container="body" class="d-inline-block">
														<button type="button" class="btn btn-primary btn-sm"
															ngbDropdownToggle><i
																class="ri-mail-line me-1"></i>Email</button>
														<div ngbDropdownMenu>
															<button ngbDropdownItem (click)="resetPassword(row)"><i
																	class="ri-lock-password-line me-1"></i>Reset
																password</button>
															<button ngbDropdownItem (click)="testEmail(row)"><i
																	class="ri-mail-check-line me-1"></i>Test
																email</button>
															<button ngbDropdownItem
																*ngIf="row.portalType === 'Customer'"
																(click)="sendLinkToCustomer(row)">
																<i class="ri-send-plane-line me-1"></i>Welcome email
																<i class="ri-checkbox-circle-fill text-success ms-1"
																	*ngIf="row.welcome_email_sent == 1"></i>
															</button>
															<button ngbDropdownItem
																*ngIf="row.portalType === 'Employee'"
																(click)="sendPasswordEmployeeCreation(row.email1, row.name)">
																<i class="ri-send-plane-line me-1"></i>Welcome email
																<i class="ri-checkbox-circle-fill text-success ms-1"
																	*ngIf="row.welcome_email_sent == 1"></i>
															</button>
														</div>
													</div>
												</td>
											</tr>

											<tr *ngIf="allUsers?.length === 0">
												<td colspan="5" class="text-center text-muted py-3">No users found.</td>
											</tr>
										</tbody>
										<tfoot>
											<tr>
												<td colspan="5" class="title-footer" style="padding-left: 5px">
													<strong>Total Users: </strong>{{ allUsers?.length }}</td>
											</tr>
										</tfoot>
									</table>
								</div>
							</div>
						</ng-template>
					</li>

					<!-- <li [ngbNavItem]="2">
						<a ngbNavLink>Views Permissions</a>
						<ng-template ngbNavContent>
							<app-permissions></app-permissions>
						</ng-template>
					</li> -->
				</ul>

				<div [ngbNavOutlet]="nav" class="mt-0"></div>
			</div>
		</div>
	</div>
</div>

<!-- modal -->
<ng-template #addUserModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title"><i class="ri-user-add-line me-2"></i>Add New User</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>

	<div class="modal-body">
		<div class="d-flex align-items-center mb-4">
			<div class="d-flex flex-column align-items-center">
				<div class="wizard-step-circle" [class.active]="wizardStep >= 1" [class.done]="wizardStep > 1">
					<i *ngIf="wizardStep > 1" class="ri-check-line"></i>
					<span *ngIf="wizardStep <= 1">1</span>
				</div>
				<small class="mt-1 text-muted" style="font-size: 10px">Basic Info</small>
			</div>
			<div class="wizard-line" [class.done]="wizardStep > 1"></div>

			<div class="d-flex flex-column align-items-center">
				<div class="wizard-step-circle" [class.active]="wizardStep >= 2" [class.done]="wizardStep > 2">
					<i *ngIf="wizardStep > 2" class="ri-check-line"></i>
					<span *ngIf="wizardStep <= 2">2</span>
				</div>
				<small class="mt-1 text-muted" style="font-size: 10px">
					{{ selectedUserType === "customer" ? "Contact" : "Access" }}
				</small>
			</div>

			<ng-container *ngIf="selectedUserType === 'customer'">
				<div class="wizard-line" [class.done]="wizardStep > 2"></div>
				<div class="d-flex flex-column align-items-center">
					<div class="wizard-step-circle" [class.active]="wizardStep >= 3" [class.done]="wizardStep > 3">
						<i *ngIf="wizardStep > 3" class="ri-check-line"></i>
						<span *ngIf="wizardStep <= 3">3</span>
					</div>
					<small class="mt-1 text-muted" style="font-size: 10px">Location</small>
				</div>
				<div class="wizard-line" [class.done]="wizardStep > 3"></div>
				<div class="d-flex flex-column align-items-center">
					<div class="wizard-step-circle" [class.active]="wizardStep >= 4">
						<span>4</span>
					</div>
					<small class="mt-1 text-muted" style="font-size: 10px">LMS Info</small>
				</div>
			</ng-container>
		</div>

		<div *ngIf="wizardStep === 1">
			<form [formGroup]="basicInfoForm">
				<div class="row mb-3">
					<div class="col-6">
						<label class="form-label fw-medium">First Name <span class="text-danger">*</span></label>
						<input type="text" class="form-control" formControlName="name" placeholder="First Name"
							[ngClass]="{ 'is-valid': basicInfoForm.get('name')?.touched && basicInfoForm.get('name')?.valid, 'is-invalid': basicInfoForm.get('name')?.touched && basicInfoForm.get('name')?.invalid }" />
					</div>
					<div class="col-6">
						<label class="form-label fw-medium">Last Name <span class="text-danger">*</span></label>
						<input type="text" class="form-control" formControlName="lastname" placeholder="Last Name"
							[ngClass]="{ 'is-valid': basicInfoForm.get('lastname')?.touched && basicInfoForm.get('lastname')?.valid, 'is-invalid': basicInfoForm.get('lastname')?.touched && basicInfoForm.get('lastname')?.invalid }" />
					</div>
				</div>
				<div class="row mb-4">
					<div class="col-12">
						<label class="form-label fw-medium">Email <span class="text-danger">*</span></label>
						<input type="email" class="form-control" formControlName="email" placeholder="Email address"
							[ngClass]="{ 'is-valid': basicInfoForm.get('email')?.touched && basicInfoForm.get('email')?.valid, 'is-invalid': basicInfoForm.get('email')?.touched && basicInfoForm.get('email')?.invalid }" />
					</div>
				</div>

				<label class="form-label fw-medium mb-3"><i class="ri-shield-user-line me-1"></i> Select User Type <span
						class="text-danger">*</span></label>
				<div class="row g-3">
					<div class="col-4">
						<div class="user-type-card" [class.selected]="selectedUserType === 'customer'"
							(click)="selectUserType('customer')">
							<div class="user-type-icon bg-info-subtle text-info"><i class="ri-user-heart-line"></i>
							</div>
							<div class="fw-semibold mt-2">Customer</div>
							<small class="text-muted">Client portal user</small>
							<div class="user-type-check" *ngIf="selectedUserType === 'customer'">
								<i class="ri-checkbox-circle-fill text-info"></i>
							</div>
						</div>
					</div>
					<div class="col-4">
						<div class="user-type-card" [class.selected]="selectedUserType === 'admin'"
							(click)="selectUserType('admin')">
							<div class="user-type-icon bg-danger-subtle text-danger"><i class="ri-admin-line"></i></div>
							<div class="fw-semibold mt-2">Admin</div>
							<small class="text-muted">Full system access</small>
							<div class="user-type-check" *ngIf="selectedUserType === 'admin'">
								<i class="ri-checkbox-circle-fill text-danger"></i>
							</div>
						</div>
					</div>
					<div class="col-4">
						<div class="user-type-card" [class.selected]="selectedUserType === 'caller'"
							(click)="selectUserType('caller')">
							<div class="user-type-icon bg-success-subtle text-success"><i class="ri-phone-line"></i>
							</div>
							<div class="fw-semibold mt-2">Caller</div>
							<small class="text-muted">Call center agent</small>
							<div class="user-type-check" *ngIf="selectedUserType === 'caller'">
								<i class="ri-checkbox-circle-fill text-success"></i>
							</div>
						</div>
					</div>
				</div>
				<div class="text-danger mt-2" style="font-size: 12px" *ngIf="typeNotSelected">Please select a user type
					to continue.</div>
			</form>
		</div>

		<div *ngIf="wizardStep === 2 && selectedUserType !== 'customer'">
			<form [formGroup]="employeeExtraForm">
				<div class="row mb-4">
					<div class="col-12">
						<label class="form-label fw-medium">Ring Central Extension <span
								class="text-danger">*</span></label>
						<input type="number" class="form-control" formControlName="ringcentral_ext"
							placeholder="Example: 102"
							[ngClass]="{ 'is-valid': employeeExtraForm.get('ringcentral_ext')?.touched && employeeExtraForm.get('ringcentral_ext')?.valid, 'is-invalid': employeeExtraForm.get('ringcentral_ext')?.touched && employeeExtraForm.get('ringcentral_ext')?.invalid }" />
					</div>
				</div>
				<hr />
				<h6 class="text-muted text-uppercase fw-semibold mb-3"><i class="ri-shield-keyhole-line me-1"></i> Roles
					& Permissions</h6>
				<div class="row g-3">
					<!-- DB Reset: visible para ambos, pre-seteado según tipo -->
					<div class="col-4">
						<div class="card border shadow-none mb-0">
							<div class="card-body p-3 text-center">
								<div
									class="form-check form-switch form-switch-danger d-flex justify-content-center mb-1">
									<input class="form-check-input" type="checkbox" formControlName="isDbReset"
										role="switch" />
								</div>
								<label class="fw-medium">DB Reset</label>
								<p class="text-muted mb-0" style="font-size: 11px">DB reset access</p>
							</div>
						</div>
					</div>

					<div class="col-4" *ngIf="selectedUserType === 'admin' && isSuperAdmin">
						<div class="card border shadow-none mb-0">
							<div class="card-body p-3 text-center">
								<div class="form-check form-switch form-switch-primary d-flex justify-content-center mb-1">
									<input class="form-check-input" type="checkbox" formControlName="isSuperAdmin" role="switch" />
								</div>
								<label class="fw-medium">SuperAdmin</label>
								<p class="text-muted mb-0" style="font-size: 11px">Full system access</p>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>

		<div *ngIf="wizardStep === 2 && selectedUserType === 'customer'">
			<h6 class="text-muted text-uppercase fw-semibold mb-3"><i class="ri-contacts-line me-1"></i> Contact
				Information</h6>
			<form [formGroup]="contactInfoForm">
				<div class="row mb-3">
					<div class="col-12">
						<label class="form-label fw-medium">Company Name <span class="text-danger">*</span></label>
						<input type="text" class="form-control" formControlName="company_name"
							placeholder="Company Name"
							[ngClass]="{ 'is-valid': contactInfoForm.get('company_name')?.touched && contactInfoForm.get('company_name')?.valid, 'is-invalid': contactInfoForm.get('company_name')?.touched && contactInfoForm.get('company_name')?.invalid }" />
					</div>
				</div>
				<div class="row mb-3">
					<div class="col-6">
						<label class="form-label fw-medium">Email 2</label>
						<input type="email" class="form-control" formControlName="email2" placeholder="Email 2" />
					</div>
					<div class="col-6">
						<label class="form-label fw-medium">Email 3</label>
						<input type="email" class="form-control" formControlName="email3" placeholder="Email 3" />
					</div>
				</div>
				<div class="row mb-3">
					<div class="col-6">
						<label class="form-label fw-medium">Mobile Phone</label>
						<input type="tel" class="form-control" formControlName="mobile_phone" placeholder="Mobile Phone"
							maxlength="10" (input)="utils.inputSanitizeNumber($event)" />
					</div>
					<div class="col-6">
						<label class="form-label fw-medium">Phone Home</label>
						<input type="tel" class="form-control" formControlName="phone_home" placeholder="Phone Home"
							maxlength="10" (input)="utils.inputSanitizeNumber($event)" />
					</div>
				</div>
				<div class="row">
					<div class="col-6">
						<label class="form-label fw-medium">Phone Work</label>
						<input type="tel" class="form-control" formControlName="phone_work" placeholder="Phone Work"
							maxlength="10" (input)="utils.inputSanitizeNumber($event)" />
					</div>
					<div class="col-6">
						<label class="form-label fw-medium">Phone Other</label>
						<input type="tel" class="form-control" formControlName="phone_other" placeholder="Phone Other"
							maxlength="10" (input)="utils.inputSanitizeNumber($event)" />
					</div>
				</div>
			</form>
		</div>

		<div *ngIf="wizardStep === 3 && selectedUserType === 'customer'">
			<h6 class="text-muted text-uppercase fw-semibold mb-3"><i class="ri-map-pin-line me-1"></i> Location</h6>
			<form [formGroup]="locationForm">
				<div class="row mb-3">
					<div class="col-6">
						<label class="form-label fw-medium">Address</label>
						<input type="text" class="form-control" formControlName="address" placeholder="Address" />
					</div>
					<div class="col-6">
						<label class="form-label fw-medium">Timezone</label>
						<select class="form-control" formControlName="timezone">
							<option value="" disabled selected>Select Timezone</option>
							<option *ngFor="let tz of timezones" [value]="tz.shortName">{{ tz.name }}</option>
						</select>
					</div>
				</div>
				<div class="row">
					<div class="col-4">
						<label class="form-label fw-medium">City</label>
						<input type="text" class="form-control" formControlName="city" placeholder="City" />
					</div>
					<div class="col-4">
						<label class="form-label fw-medium">State</label>
						<select class="form-control" formControlName="state">
							<option value="" disabled selected>Select State</option>
							<option *ngFor="let st of states" [value]="st.shortName">{{ st.name }}</option>
						</select>
					</div>
					<div class="col-4">
						<label class="form-label fw-medium">Zip Code</label>
						<input type="tel" class="form-control" formControlName="zip_code" placeholder="Zip Code"
							maxlength="6" (input)="utils.inputSanitizeNumber($event)" />
					</div>
				</div>
			</form>
		</div>

		<div *ngIf="wizardStep === 4 && selectedUserType === 'customer'">
			<h6 class="text-muted text-uppercase fw-semibold mb-3"><i class="ri-settings-3-line me-1"></i> LMS
				Information</h6>
			<form [formGroup]="lmsInfoForm">
				<div class="row mb-3">
					<div class="col-6">
						<label class="form-label fw-medium">Account Associated <span
								class="text-danger">*</span></label>
						<select class="form-control" formControlName="account_associated"
							[ngClass]="{ 'is-valid': lmsInfoForm.get('account_associated')?.touched && lmsInfoForm.get('account_associated')?.valid, 'is-invalid': lmsInfoForm.get('account_associated')?.touched && lmsInfoForm.get('account_associated')?.invalid }">
							<option value="" disabled selected>Select Account</option>
							<option *ngFor="let emp of employeeUsersForSelect" [value]="emp.login">{{ emp.login }}
							</option>
						</select>
					</div>
					<br />
					<div class="row mt-3">
						<div class="col-4"></div>
						<div class="col-4" align="center">
							<div class="form-check form-switch form-switch-lg" dir="ltr" align="center">
								<input type="checkbox" class="form-check-input" [(ngModel)]="linkCampaign"
									(click)="linkCampaignToggle()" [ngModelOptions]="{ standalone: true }" />
								<label class="form-check-label" for="customSwitchsizelg">¿Link user to campaign?</label>
							</div>
						</div>
						<div class="col-4"></div>
					</div>
					<div class="row">
						<div class="col-2"></div>
						<div class="col-8" align="center">
							<p class="text-muted" *ngIf="!linkCampaign">If this is deactivated, the user will be created
								with a new alias. You will then be able to create a new campaign after completing this
								step.</p>
							<p class="text-muted" *ngIf="linkCampaign">The new user will be linked to the selected
								campaign through their alias.</p>
						</div>
						<div class="col-2"></div>
					</div>
					<br />
					<div class="row" *ngIf="linkCampaign">
						<div class="col-4"></div>
						<div class="col-4" align="center">
							<h3 class="labels">Alias</h3>
							<input type="text" id="alias" placeholder="Alias" class="form-control" disabled
								[value]="lmsInfoForm.get('alias').value" />
						</div>
						<div class="col-4"></div>
					</div>
					<br />

					<div class="row" *ngIf="linkCampaign">
						<div class="col-3"></div>
						<div class="col-6" align="center">
							<h3 class="labels">Select Campaign</h3>
							<select id="campaign" class="form-control" (change)="onCampaignSelect($event)"
								formControlName="alias"
								[ngClass]="{ 'is-valid': lmsInfoForm.get('alias')?.touched && lmsInfoForm.get('alias')?.valid, 'is-invalid': lmsInfoForm.get('alias')?.touched && lmsInfoForm.get('alias')?.invalid }">
								<option value="" disabled selected>Select your Campaign</option>
								<option *ngFor="let campaign of campaigns" [value]="campaign.alias">{{ campaign.name }}
								</option>
							</select>
						</div>
						<div class="col-3"></div>
					</div>
				</div>
			</form>
		</div>
	</div>
	<div class="modal-footer d-flex justify-content-between">
		<button type="button" class="btn btn-light" (click)="wizardBack()" *ngIf="wizardStep > 1"><i
				class="bx bx-arrow-back me-1"></i> Back</button>
		<button type="button" class="btn btn-light" (click)="modal.dismiss()" *ngIf="wizardStep === 1">Cancel</button>
		<button type="button" class="btn btn-primary" *ngIf="!isLastStep()" (click)="wizardNext()">Next <i
				class="ri-arrow-right-line ms-1"></i></button>
		<button type="button" class="btn btn-success" *ngIf="isLastStep()" (click)="submitNewUser()"
			[disabled]="submittingUser">
			<span *ngIf="submittingUser" class="spinner-border spinner-border-sm me-1" role="status"></span>
			<i *ngIf="!submittingUser" class="ri-user-add-line me-1"></i>
			{{ submittingUser ? "Creating..." : "Create User" }}
		</button>
	</div>
</ng-template>
